var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._v("\n  Economica\n  "+_vm._s(this.$route.path)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }